import React from 'react'
import PropTypes from 'prop-types'
import FixedEnterpriseReviewFormInner from '~/components/forms/review_form/fixed_enterprise_review_form_inner'
import ShopReviewFormStore from '~/stores/forms/reviews/shop_review_form_store'

export default class FixedShopReviewForm extends React.Component {
  static propTypes = {
    service_id: PropTypes.number,
    is_history_backable: PropTypes.bool,
    recaptcha_site_key: PropTypes.string
  }

  constructor(props) {
    super(props)
  }

  render() {
    const reviewFormStore = new ShopReviewFormStore()
    reviewFormStore.setSelectedServiceId(this.props.service_id)
    reviewFormStore.setIsHistoryBackable(this.props.is_history_backable)
    return (
      <FixedEnterpriseReviewFormInner
        reviewFormStore={reviewFormStore}
        serviceReadonlyTitle="店舗名"
        recaptchaSiteKey={this.props.recaptcha_site_key}
      />
    )
  }
}
